import { getComponentId } from 'apps/analytics/components/GraphicPageComponent';
import { wa, pageEventTypes } from 'apps/analytics';

export default function sendAdvertAnalytics(scribeDocument, parentContainer) {
  const { docNo, docVersionNo } = scribeDocument;
  const { docNo: parentNo, docVersionNo: parentVersionNo } = parentContainer;

  wa.triggerPageEvent(pageEventTypes.AD_CLICK, {
    FROM_ADVERT_DOC_NO: docNo,
    FROM_ADVERT_DOC_VERSION_NO: docVersionNo,
    FROM_ADVERT_PARENT_DOC_NO: parentNo,
    FROM_ADVERT_PARENT_DOC_VERSION_NO: parentVersionNo,
    PAGE_COMPONENT_ID: `${wa.getPageViewId()}.${getComponentId(docNo, docVersionNo)}`,
  });
}
